import React from 'react';

const FlightFareSummary = ({ selectedFlights, totalPassengers, onNext }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };

  const calculateGrandTotal = () => {
    return selectedFlights.reduce((sum, aircraft) => {
      const price = aircraft.seat_price || aircraft.block_empty_price;
      const finalPrice = aircraft.commission_fee ?
        Math.round(price + (price * aircraft.commission_fee / 100)) : price;
      return sum + (finalPrice * totalPassengers);
    }, 0);
  };

  return (
    <div className="w-80 flex-shrink-0">
      <div className="bg-white rounded-lg shadow-sm p-6 sticky top-8">
        <h5 className="text-lg font-bold text-jet-gray-900 mb-4">Fare</h5>

        <div className="space-y-4 mb-6">
          {selectedFlights.map((aircraft) => {
            const price = aircraft.seat_price || aircraft.block_empty_price;
            const finalPrice = aircraft.commission_fee ?
              Math.round(price + (price * aircraft.commission_fee / 100)) : price;

            return (
              <div key={aircraft.id} className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-sm font-bold text-jet-gray-900">
                      {aircraft.dep_airport_code}
                    </span>
                    <span className="text-sm text-jet-gray-600 mx-4">→</span>
                    <span className="text-sm font-bold text-jet-gray-900">
                      {aircraft.arr_airport_code}
                    </span>
                  </div>
                  <div className="text-xs text-jet-gray-600 space-y-1">
                    <div>Passenger(s)</div>
                    <div>Fare/Pax</div>
                    <div>Total Fare</div>
                  </div>
                </div>
                <div className="text-right text-xs text-jet-gray-900 space-y-1">
                  <div></div>
                  <div className="font-semibold">{totalPassengers}</div>
                  <div className="font-semibold">{formatCurrency(finalPrice)}</div>
                  <div className="font-semibold">{formatCurrency(finalPrice * totalPassengers)}</div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="border-t border-jet-gray-200 pt-4 mb-6">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-bold text-jet-gray-900">Total Passenger(s)</span>
            <span className="text-sm font-bold text-jet-gray-900">{totalPassengers}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm font-bold text-jet-gray-900">Grand Total</span>
            <span className="text-sm font-bold text-jet-gray-900">{formatCurrency(calculateGrandTotal())}</span>
          </div>
        </div>

        <div className="text-center">
          <button
            onClick={onNext}
            className="w-full bg-jet-green-600 hover:bg-jet-green-700 text-white font-medium py-3 px-4 rounded-md transition-colors"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default FlightFareSummary;
